import Styleguide, { Colors, theme } from "src/theme";
import styled from "styled-components";

export const Title = styled.h1`
  margin: 0;
  color: ${Colors.white};

  font-family: ${Styleguide.fonts.heading.name};
  font-weight: ${Styleguide.fontWeights.semibold};
  font-size: ${Styleguide.fontSizes[22]};
  font-feature-settings: ${Styleguide.fonts.heading.settings};

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    font-size: ${Styleguide.fontSizes[28]};
  }
`;

export const Text = styled.p<{
  $mobileTextAlign?: string;
  $tabletTextAlign?: string;
}>`
  color: ${Colors.gray[100]};
  font-family: ${Styleguide.fonts.body.name};
  font-weight: ${Styleguide.fontWeights.regular};
  font-size: ${Styleguide.fontSizes[16]};
  text-align: ${(props) => props.$mobileTextAlign || "left"};
  margin: 0;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    font-size: ${Styleguide.fontSizes[18]};
    text-align: ${(props) => props.$tabletTextAlign || "left"};
  }
`;

export const TitleList = styled.h2`
  color: ${Colors.gray[100]};
  font-family: ${Styleguide.fonts.heading.name};
  font-weight: ${Styleguide.fontWeights.semibold};
  font-size: ${Styleguide.fontSizes[18]};
  margin: 0;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    font-size: ${Styleguide.fontSizes[24]};
  }
`;

export const TextList = styled.ul`
  color: ${Colors.gray[100]};
  font-family: ${Styleguide.fonts.body.name};
  font-weight: ${Styleguide.fontWeights.regular};
  font-size: ${Styleguide.fontSizes[14]};
  margin: 0;
  padding-left: 16px;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    font-size: ${Styleguide.fontSizes[18]};
  }

  li {
    margin-bottom: 16px;
    vertical-align: top;

    a {
      color: ${Colors.lightBlue[100]};
      text-decoration: underline;
      font-weight: ${Styleguide.fontWeights.bold};
      cursor: pointer;

      :focus-visible {
        outline-width: 3px;
        outline-style: solid;
        border-radius: 8px;
        outline-offset: 2px;
        outline-color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
      }
    }
  }
`;

export const MobileBreak = styled.br`
  display: block;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    display: none;
  }
`;
